import { GLOBAL_ROLES, APP_ROLES } from "shared-frontend";

export const PERMISSION_SETS = {
    ADMIN: [
        GLOBAL_ROLES.ADMIN,
        APP_ROLES.FACULTY_ANNOUNCEMENT_NET_ADMIN
    ],
    SANDRA: [APP_ROLES.SANDRA]
}